module.exports = __webpack_public_path__ + "img/Group 1917.429da30d.svg";